import React, { useEffect, useState } from "react";
import { Button, FormControl, InputGroup, Spinner } from "react-bootstrap";
import { isEmpty } from "lodash";
import { fourPlaceHolder, groupSlots, specialSubCategories } from "modules/utilities/utility";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";
import { useConsultDoctor, useTicketHistory } from "../actionables/store";
import { createMeidcalEscalationTicket } from "modules/navbar/top/store";

function MedicalSlotBooking({
  caseId,
  slotBooking = false,
  formCategory,
  orderDisplayId,
  ticketObject,
  setTicketObject,
}) {
  const {
    slotData,
    allSlotData,
    postSlotLoading,
    allSlotLoading,
    isLoading,
    postSlotDoctorApiData,
    fetchMedicalSlotData,
  } = useConsultDoctor();
  const { fetchMeidcalCreateTicket, slotDetails, nearestSlot } = createMeidcalEscalationTicket();

  const [filterSlotData, setFilterSlotData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const sessionId = uuidv4();

  useEffect(() => {
    setFilterSlotData(null);
    if (slotBooking) {
      fetchMedicalSlotData(caseId, sessionId, toast);
    }
  }, []);

  useEffect(() => {
    if (slotBooking) {
      if (!isEmpty(allSlotData)) {
        const groupSlot = groupSlots(allSlotData);
        setFilterSlotData(groupSlot);
      }
    } else {
      if (!isEmpty(slotData)) {
        const groupSlot = groupSlots(slotData);

        setFilterSlotData(groupSlot);
      } else {
        setFilterSlotData([]);
      }
    }
  }, [slotData, allSlotData]);

  const handleDate = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
  };

  const handleClose = () => {
    setSelectedDate(null);
    setFilterSlotData(null);
    setSelectedSlot(null);
    setTicketObject(null);
  };

  const handleDoctorSlot = (slot) => {
    setSelectedSlot(slot);

  };



  const handleBookSlot = () => {
    const selectedSlotPayload = {
      caseId: caseId,
      slotId: selectedSlot.id,
      availableSlots: selectedSlot?.slots,
      orderRelated: false,
      isRescheduling: true,
      sessionId: sessionId,
      fromCrm: true,
      isMedicalEscalation: true,
    };
    const ticketPayload = { ...ticketObject, slotBooking: selectedSlotPayload };
    if (!formCategory) {
      toast.warning("Please select subcategory");
    }
    if (!orderDisplayId) {
      toast.warning("Please select order display Id");
    }
    if (slotBooking && formCategory && orderDisplayId) {
      if (nearestSlot && nearestSlot.rep_id) {
        const ticketPayload = { ...ticketObject, slotTime: nearestSlot.slot_time };
        fetchMeidcalCreateTicket(ticketPayload, toast, true);
      } else {
        const selectedSlotPayload = {
          case_id: caseId,
          slot_id: selectedSlot.id,
          slots: selectedSlot?.slots,
          order_related: false,
          is_rescheduling: true,
          session_id: sessionId,
          from_crm: true,
          is_medical_escalation: true,
        };
        postSlotDoctorApiData(selectedSlotPayload, toast, handleClose, ticketPayload, fetchMeidcalCreateTicket);
      }
    }
  };

  const bookLoading = slotBooking ? postSlotLoading : isLoading;

  return (
    <>
      <div className='border-bottom border-1 p-0 m-0'>
        {!specialSubCategories.includes(formCategory) &&
          <>
            {slotBooking ? (allSlotLoading ? fourPlaceHolder() : null) : null}
            {filterSlotData && Object.keys(filterSlotData).length > 0 ?
              <>
                <div className="d-flex gap-2 flex-wrap justify-content-center my-3">
                  {Object.keys(filterSlotData)?.map((slotDate) => {
                    return (
                      <div
                        className="cursor-pointer"
                        onClick={() => handleDate(slotDate)}
                      >
                        <div className={`p-3 m-2 rounded-pill ${slotDate == selectedDate ? `border border-1 border-primary text-primary fw-bold` : `border border-1 fw-bold`}`}>
                          <h5 className={`p-0 m-0 fw-bold ${slotDate == selectedDate ? `text-primary` : ``}`}>{moment(slotDate).format("ddd ")} {slotDate}</h5>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div
                  className="d-flex gap-3 flex-wrap my-4 px-2 scrollable-container justify-content-center"
                  style={{ maxHeight: "50vh", overflowY: "scroll" }}
                >
                  {selectedDate &&
                    filterSlotData[selectedDate].slice(0, -2)?.map((timeSlot) => {
                      return (
                        <Button
                          style={{ width: "100px", fontSize: 14 }}
                          onClick={() => handleDoctorSlot(timeSlot)}
                          className={
                            timeSlot?.slots?.count === 0
                              ? " py-2 bg-secondary text-white rounded-5 cursor-na disabled pointer-events-none text-center"
                              : selectedSlot?.slotTime == timeSlot?.slotTime
                                ? "py-2 bg-primary text-white rounded-5 cursor-pointer text-center"
                                : " py-2 rounded-5  bg-white text-black border border-secondary cursor-pointer text-center"
                          }
                        >
                          {moment(timeSlot?.slotTime).format("hh:mm A")}
                        </Button>
                      );
                    })}
                </div>
              </>
              : <div className='d-flex justify-content-center pt-2 pb-3'>
              <h3 className='p-0 m-0 text-secondary'>No Slots available </h3>
              </div>}

          </>
        }
        {specialSubCategories.includes(formCategory) && nearestSlot && nearestSlot.rep_id && <InputGroup className="mt-4 mb-2 d-flex">
          <InputGroup.Text id="inputGroup-sizing-default" className='flex-1'><h4 className='p-0 m-0'>Nearest Slot</h4></InputGroup.Text>
          <FormControl
            aria-label="Default"
            className='fs-2 flex-1'
            disabled
            value={nearestSlot ? moment(nearestSlot?.slot_time).format('hh:mm, MMMM Do YYYY') : '-'}
            aria-describedby="inputGroup-sizing-default"
          />
        </InputGroup>}
        {(selectedSlot || (nearestSlot && nearestSlot.rep_id)) && (
          slotDetails ? <div>
            <InputGroup className="mt-4 mb-2 d-flex">
              <InputGroup.Text id="inputGroup-sizing-default" className='flex-1'><h4 className='p-0 m-0'>Slot Time</h4></InputGroup.Text>
              <FormControl
                aria-label="Default"
                className='fs-2 flex-1'
                disabled
                value={slotDetails ? moment(slotDetails?.medical_slot_time).format('hh:mm, MMMM Do YYYY') : '-'}
                aria-describedby="inputGroup-sizing-default"
              />
            </InputGroup>  
            <InputGroup className="mt-4 mb-2 d-flex">
              <InputGroup.Text id="inputGroup-sizing-default" className='flex-1'><h4 className='p-0 m-0'>Assigned Rep</h4></InputGroup.Text>
              <FormControl
                aria-label="Default"
                className='fs-2 flex-1'
                disabled
                value={ slotDetails.medical_slot_assignment}
                aria-describedby="inputGroup-sizing-default"
              />
            </InputGroup>  
          </div> : <Button className="mt-5 py-2 fs-1 w-100 " onClick={handleBookSlot}>
            {bookLoading ? (
              <span className="d-flex flex-row gap-2 justify-content-center">
                <Spinner animation="border" variant="light" />

                <span>Booking Call and Creating Ticket</span>
              </span>
            ) : (
              <span>
                <span>Booking Call and Create Ticket</span>
              </span>
            )}
          </Button>
        )}
      </div>
    </>
  );
}

export default MedicalSlotBooking;